import ax from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;


const axios = ax.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

export default axios;

export const unAuthAxios = ax.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

// use for non authenticated request e.g: login, logout
